



























































































import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import AbstractField from '@shared/components/forms/inputs/abstract-field/abstract-field';
import AbstractSelect from '@shared/components/forms/inputs/abstract-select/abstract-select';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import FieldWrapper from '@shared/components/forms/inputs/field-wrapper/field-wrapper.vue';
import BPCListQueryConfig from '@core/interfaces/bpc-list-query-config';

@Component({
  name: 'bc-resource-filter',
  components: {
    'bpc-field-wrapper': FieldWrapper,
    'bpc-entity-table-provider': EntityTableProvider,
    'v-select': vSelect,
  },
})
export default class ResourceFilter extends mixins(AbstractField, AbstractSelect) {
  $refs!: {
    provider: InstanceType<typeof EntityTableProvider> & {
      getEntities(clearItems?: boolean): void;
      getConfig(): void;
      loading: boolean;
      accumulateItems: boolean;
      items: any[];
      pagination: any;
      queryConfig: BPCListQueryConfig;
    };
    load: any;
  };
  @Prop({ type: Number, default: 25 }) readonly selectItemsPerPage: number;
  @Prop({ type: Boolean, default: false }) readonly onlyLoadOnOpen: boolean;
  @Prop({
    type: Array,
    default: () => {
      return [];
    },
  })
  readonly filters: any[];

  public firstTimeOpened = true;
  public observer = null;

  mounted() {
    if (this.onlyLoadOnOpen) {
      this.firstTimeOpened = false;
    }
    this.observer = new IntersectionObserver(this.infiniteScroll);
  }

  async infiniteScroll(entries: { isIntersecting: boolean; target: any }[]) {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        if (!this.$refs.provider.loading) {
          this.$refs.provider.accumulateItems = true;
          this.$refs.provider.pagination.current_page += 1;
        }
      }
    }
  }

  myDropdownShouldOpen({ noDrop, open }) {
    return noDrop ? false : open;
  }

  async itemsLoaded() {
    if (this.$refs.load) {
      const ul = this.$refs.load.offsetParent;
      const scrollTop = ul.scrollTop;
      await this.$nextTick();
      ul.scrollTop = scrollTop;
    }

    this.$emit('items-loaded', this.$refs.provider.items);

    if (this.$refs.load) {
      this.observer.disconnect();
      this.observer.observe(this.$refs.load);
    }
  }

  async onOpen() {
    if (!this.firstTimeOpened) {
      this.$refs.provider.getConfig();
      this.firstTimeOpened = true;
    }
    if (this.hasNextPage) {
      await this.$nextTick();
      if (this.$refs.load) {
        this.observer.observe(this.$refs.load);
      }
    }
  }
  onClose() {
    this.observer.disconnect();
  }

  hasNextPage() {
    return (
      this.$refs.provider &&
      this.$refs.provider.pagination.last_page > this.$refs.provider.pagination.current_page
    );
  }

  extendHandleEvent(eventName: string, event: any, val: any) {
    if (event.action === 'getEntities') {
      this.$refs.provider.items = [];
      this.model = null;
      this.$refs.provider.getEntities();
    }
  }

  getEntities() {
    this.$refs.provider.getEntities();
  }
}
